// extracted by mini-css-extract-plugin
export default {"descriptiveTableHeader":"styles_descriptiveTableHeader__yjZEF","descriptiveTableContent":"styles_descriptiveTableContent__PTxTB","centerSaveButton":"styles_centerSaveButton__PkIwK"};